/*!
* @copyright
* Copyright(c) 2018 SICK AG
*/
const style = `* {
  box-sizing: border-box;
}

:host {
  color: #007CC1;
  color: var(--davinci-color-primary, #007CC1);
  display: grid;
  width: 100%;
  contain: content;
}
:host #container {
  overflow: hidden;
  font-weight: 600;
  display: flex;
  row-gap: 1rem;
  flex-direction: column;
  justify-content: center;
  text-align: center;
}
:host #container #valtext {
  flex-wrap: nowrap;
  justify-content: center;
  align-content: center;
  align-items: baseline;
}
:host #container #subtext {
  max-height: -webkit-min-content;
  max-height: -moz-min-content;
  max-height: min-content;
  white-space: nowrap;
  text-overflow: ellipsis;
  color: #737F85;
  color: var(--davinci-color-text-lighter, #737F85);
}

:host([hidden]) {
  display: none;
}

:host #container #valtext {
  display: flex;
}
:host #container #valtext :nth-child(1) {
  align-self: auto;
  text-overflow: ellipsis;
  white-space: nowrap;
}
:host #container #valtext :nth-child(2) {
  align-self: auto;
}`;
export { style };
